// extracted by mini-css-extract-plugin
export default {"strokeMarketplaceColor":"IconKeys_strokeMarketplaceColor__1GUZ6"};